import configs from './configurations';

const DEFAULT = {
    brandingFeatures: {
        logo_url: "raven-logo",
        app_name_prefix: null,
        theme_selection: "light", // 'light', 'dark', or to hide theme selection set to undefined,
    },
    globals: {
        supportUrl: 'https://klashwerks.zendesk.com/hc',
        supportPhoneNumber: '1-833-842-0439',
        supportEmail: 'support@ravenconnected.com',
        salesEmail: 'sales@raven.is',
        supportHoursDescriptionStringKey: 'contact_us_support_hours_description',
        facialRecognitionBadgeStringKey: 'facial_recognition_badge',
        ravenHomeUrl: 'https://ravenconnected.com/',
        eulaUrl: 'http://legal.raven.is/WebAppEULA.html',
        fleetManagersGuideUrl: 'https://klashwerks.zendesk.com/hc/en-us/articles/4402752940055',
        installingRavenGuideUrl: 'https://ravenconnected.com/install/',
        ravenHome: 'ravenconnected.com',
        buyRavenUrl: 'https://ravenconnected.com/pricing',
        whatsNewUrl: 'https://klashwerks.zendesk.com/hc/en-us/categories/8109655013527-What-s-New',
    }
};

const FALLBACK_CHANNEL_BRANDING_URLS = {
    channel_branding_base_url: null,
    logo_url: DEFAULT.brandingFeatures.logo_url,
    splash_asset: null
};

const getChannelBrandingFeatures = (channelCode) => {
    const normalizedChannelCode = channelCode ? channelCode.toLowerCase() : '';
    const channelConfig = configs[normalizedChannelCode] || {};
    const brandingFeatures = channelConfig.brandingFeatures || {};
    return { ...DEFAULT.brandingFeatures, ...brandingFeatures };
};

const getChannelBuildFeatures = (channelCode) => {
    const normalizedChannelCode = channelCode ? channelCode.toLowerCase() : '';
    const channelConfig = configs[normalizedChannelCode] || {};
    return channelConfig.buildFeatures || null;
};

const getChannelGlobals = (channelCode) => {
    const normalizedChannelCode = channelCode ? channelCode.toLowerCase() : '';
    const channelConfig = configs[normalizedChannelCode] || {};
    const globals = channelConfig.globals || {};
    return { ...DEFAULT.globals, ...globals };
};

export {
    getChannelBrandingFeatures,
    getChannelBuildFeatures,
    getChannelGlobals,
    FALLBACK_CHANNEL_BRANDING_URLS
};
